import { i18n } from '@international/mastodon-i18n';
import { SearchRecord } from 'types/record';
import { getChargeTitle } from '../../../../lib/screenings';

type Props = {
  record?: SearchRecord;
};

const CandidateStoryItemTitle = ({ record }: Props) => {
  const title = record
    ? getChargeTitle(record)
    : i18n.getStr('components.Report.CandidateStories.generalInformation');

  return title;
};

export default i18n.renderTranslation()(CandidateStoryItemTitle);
